import React, { useEffect, useState } from 'react';
import { BsFillArrowRightCircleFill } from "react-icons/bs";
import { Link } from 'react-router-dom';
import { getServices } from '../../api/api';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import Service from '../../components/Service/Service';
import './FeaturedServices.scss';

const FeaturedServices = () => {
  const [services, setServices] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const data = await getServices();
      setServices(data.slice(0, 4)); // Only first 4 services
    }
    fetchData();
  }, []);

  return (
    <section className="featured-service-section pt-100 pb-70" data-aos="fade-up" data-aos-duration="2000">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-sm-6">
            <SectionTitle
              title="Feel amazing about your oral health"
              subTitle="Featured Services"
            />
          </div>
          <div className="col-lg-6 col-sm-6">
            <p className="service-title-text">
              From routine check-ups to advanced treatments, we provide
              personalized solutions for a healthier, brighter smile!
            </p>
          </div>
        </div>

        <div className="row">
          {services.map((singleService) => (
            <Service key={singleService.id} serviceList={singleService} />
          ))}
        </div>
      </div>

      <div className="services-link text-center">
        <Link to="/services">
          View all services
          <BsFillArrowRightCircleFill />
        </Link>
      </div>
    </section>
  );
};

export default FeaturedServices; 